// Big warning when QuickBooks could not be reached (invoices / payments missing from the balances).
// Part of the Balances page (components/Balances.jsx). Split out 2026-10-14.

export default function QboWarning({ data, from, handleQboReconnect, qboReconnectMsg, recon, to, totals }) {
  return (
    <>
      {/* BIG QBO WARNING. Shown whenever balances-recon returns qboError —
          i.e. the OAuth refresh token expired / was revoked / got out of sync.
          Invoice totals on this page will be MISSING until the user
          reauthorizes. Banner is impossible to miss: red border, red bg,
          dedicated Reconnect button. */}
      {data && data.qboError && (
        <div style={{
          padding: '1rem 1.2rem',
          marginBottom: '0.75rem',
          background: '#fef2f2',
          border: '2px solid #dc2626',
          borderRadius: 6,
          color: '#7f1d1d'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap' }}>
            <strong style={{ fontSize: '1.1em' }}>QuickBooks connection is broken — invoice data is missing from this page.</strong>
          </div>
          <div className="small" style={{ marginTop: '0.4rem' }}>
            All tip activity, balances snapshots, and adjustments are still showing — but invoice totals are 0 (or stale from the response cache) because the OAuth refresh token has expired or been revoked. Click below to reconnect.
          </div>
          <div className="small" style={{ marginTop: '0.4rem', color: '#9f1239', fontFamily: 'monospace' }}>
            {String(data.qboError).slice(0, 220)}
          </div>
          <div style={{ marginTop: '0.6rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <button className="refresh-btn"
                    onClick={handleQboReconnect}
                    style={{ background: '#dc2626', padding: '6px 14px', fontSize: '1em' }}>
              🔌 Reconnect to QuickBooks
            </button>
            {qboReconnectMsg && <span className="small" style={{ color: '#7f1d1d' }}>{qboReconnectMsg}</span>}
          </div>
        </div>
      )}
    </>
  );
}
